// @flow
import { Component } from 'react';

type Props = {
  isAuthenticated: boolean;
  beginSession: () => mixed,
  renewSession: () => mixed,
}

type State = {
  interval?: any;
}

const FIVE_MINUTES = 300000;

class SessionManager extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      interval: undefined,
    };
  }

  componentWillMount() {
    this.props.beginSession();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.isAuthenticated) {
      if (!this.state.interval) {
        this.setState({
          interval: setInterval(this.props.renewSession, FIVE_MINUTES),
        });
      }
    } else {
      clearInterval(this.state.interval);
      this.setState({ interval: undefined });
    }
  }

  render() {
    return null;
  }
}

export default SessionManager;



// WEBPACK FOOTER //
// ./src/common/modules/session/SessionManager.js